import Modal from '@/components/Modal';
import ComponentToggleSignal from '@/components/component-toggle-signal';
import {Image} from '@/product/types';
import {createSrcSet} from '@/utilities/create-image-src-set';
import {createShopifyImageUrl} from '@/utilities/create-shopify-image-url';

export default ProductImage;

function ProductImage({className = '', image}: ProductImageProps) {
  const modalController = new ComponentToggleSignal();

  return (
    <>
      <div className={className}>
        <img
          src={createShopifyImageUrl(image.url, 384)}
          alt={image.alt}
          onClick={() => modalController.open()}
          className="size-full cursor-pointer object-contain object-top"
        />
      </div>
      <Modal controller={modalController}>
        <div className="flex h-full items-center">
          <img
            src={image.url}
            alt={image.alt}
            className="fit-inside-modal"
            srcSet={createSrcSet(image.url, 600)}
            loading="lazy"
          />
        </div>
      </Modal>
    </>
  );
}

export type ProductImageProps = {
  image: Image;
  className?: string;
};
